<script>
import Dialog from "primevue/dialog";
import {mapActions, mapState} from "pinia";
import {managerStore} from "@/store/managerStore";
import {authStore} from "@/store/authStore";
import {baseLoaderStore} from "@/store/baseLoaderStore";

export default {
  name: "ManagerCompanyInfoMandatoryModal",
  components: {
    Dialog
  },
  computed: {
    ...mapState(managerStore, [
        'companyInfoMandatoryModalState',
        'companyInfoMandatoryModalParams'
    ]),
    ...mapState(authStore, [
      'managerProfileInfo'
    ]),
    modalState: {
      get() {
        return this.companyInfoMandatoryModalState;
      },
      set() {
        this.closeCompanyInfoMandatoryModalState();
      },
    },
  },
  methods: {
    ...mapActions(baseLoaderStore, [
      'showBaseLoader'
    ]),
    ...mapActions(managerStore, [
        'openCompanyInfoModal',
        'openCompanyInfoMandatoryModalState',
        'closeCompanyInfoMandatoryModalState'
    ]),
    enterCompanyInfo() {
      this.showBaseLoader();
      this.openCompanyInfoModal({
        editMode: true,
        managerId: this.managerProfileInfo.id
      });
      this.closeCompanyInfoMandatoryModalState();
    }
  }
}
</script>

<template>
  <Dialog v-model:visible="modalState"
          modal
          :header="$t('companyInfoMandatory.title')"
          class="manager-company-information-mandatory-modal"
  >
    <template v-if="companyInfoMandatoryModalParams && companyInfoMandatoryModalParams.type === 'TASK'">
      <div>
        <p>{{$t('companyInfoMandatory.text.task.t1')}}</p>
        <p>{{$t('companyInfoMandatory.text.task.p1')}}</p>
        <p>{{$t('companyInfoMandatory.text.task.p2')}}</p>
      </div>
    </template>
    <template v-else>
      <div>
        <p>{{$t('companyInfoMandatory.text.default.p1')}}</p>
        <p>{{$t('companyInfoMandatory.text.default.p2')}}</p>
        <p>{{$t('companyInfoMandatory.text.default.p3')}}</p>
      </div>
    </template>
    <template #footer>
      <button type="button" class="p-dialog-close-btn" @click="closeCompanyInfoMandatoryModalState()">
        {{$t('common.buttons.cancel')}}
      </button>
      <button type="button" class="p-dialog-primary-btn" @click="enterCompanyInfo()">
        {{$t('companyInfoMandatory.enterInformation')}}
      </button>
    </template>
  </Dialog>
</template>

<style lang="scss">
.manager-company-information-mandatory-modal {
  max-width: 620px;
  .p-dialog-content {
    padding: 20px;
    line-height: 18px;

    p, span {
      display: inline-block;
      margin-bottom: 5px;
    }
  }
}
</style>